module.exports = {
	"articleTitle1": "Literati assumes control of The Espresso Bar ",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Literati Coffee",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/section/statement/literati-and-renaissance-indie-bookstores",
	"articleSnippet1": "Oct 4, 2016 ... Literati owners will now oversee the business and management for the \ndowntown coffee spot, taking over for former owner Sandy Bledsoe.",
	"articleSnippet2": "Jan 26, 2016 ... I chatted over coffee with Hilary Lowe Gustafson and Michael Gustafson, the \nyoung married couple who own Literati. I asked them to look back ...",
	"foodRecommendations": [
		{
			"text": "You can have a tab running as you get coffee. It's the funniest thing.",
			"person": "Marisa Iaderosa"
		}
	],
	"articleTitle2": "Resurrecting the bookstore: Literati and the renaissance of ...",
	"address": "204 S 4th Ave, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170412/elr.BoAA_.Literati-0498.jpg?itok=ScxHPpEp",
			"author": "Emma Richter"
		}
	],
	"position": {
		"lat": 42.2802,
		"lng": -83.7475
	},
	"totalMisc": 1,
	"categories": {
		"bestofaa": 1,
		"coffeeshop": 1,
		"fooddrink": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/literaticoffee.json
// module id = 907
// module chunks = 0